"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      d: "M7.34 4.657c-.25 0-.45.2-.45.45s.2.45.45.45.45-.2.45-.45-.2-.45-.45-.45M5.99 7.81c-.323 0-.62-.17-.78-.45h1.558c-.16.28-.457.45-.78.45m1.353-1.35H4.638c-.25 0-.45.2-.45.45 0 .995.807 1.802 1.802 1.802.994 0 1.8-.807 1.8-1.803 0-.25-.2-.45-.45-.45M5.99 9.612C3.996 9.613 2.383 8 2.383 6.008c0-1.99 1.614-3.605 3.605-3.605 1.99 0 3.603 1.614 3.603 3.605 0 .956-.38 1.873-1.055 2.548-.676.676-1.594 1.057-2.548 1.057zm0-8.11c-2.49 0-4.507 2.017-4.507 4.505 0 2.49 2.018 4.506 4.506 4.506 2.488 0 4.504-2.017 4.504-4.506 0-1.194-.474-2.34-1.32-3.186-.844-.844-1.99-1.32-3.184-1.32zM4.636 5.557c.25 0 .45-.202.45-.45 0-.25-.2-.45-.45-.45s-.45.2-.45.45.2.45.45.45",
      fill: "currentColor",
      fillRule: "nonzero"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Smiley.js.map